module.exports = __webpack_public_path__ + "media/images/icons/document_type_icon-37409c5e4236f2820d86e30567492195.svg";